export function isScrollNearBottom(event: UIEvent, threshold = 0.1) {
  const node = event.target;

  return (
    node instanceof HTMLElement &&
    node.scrollHeight - node.scrollTop - node.clientHeight < node.clientHeight * threshold
  );
}
